import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { browserUtils } from '../../utils'
import alertIcon from '../../assets/icons/alert-circle.svg'
import './AuthForm.sass'


// http://emailregex.com/
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

// https://stackoverflow.com/questions/19605150/regex-for-password-must-be-contain-at-least-eight-characters-at-least-one-numbe
// Minimum eight characters, at least one letter and one number -- allows for common special characters
// const passWordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!$%@#£€*?&]{8,}$/

class AuthForm extends Component {
  state = {
    email: {
      value: '',
      isValid: false
    },
    password: {
      value: '',
      isValid: false
    },
    passwordConfirm: {
      value: '',
      isValid: false
    },
    submitAttempted: false
  }

  constructor() {
    super()
    this._validateAndSubmit = this.validateAndSubmit.bind(this)
    this._updateEmail = this.updateEmail.bind(this)
    this._updatePassword = this.updatePassword.bind(this)
    this._updatePasswordConfirm = this.updatePasswordConfirm.bind(this)
  }

  componentDidUpdate(prevProps) {
    // If form becomes visible, or if user toggles between sign-in/sign-up, give email input focus
    if ((!prevProps.isVisible && this.props.isVisible) || (prevProps.isSignInMode !== this.props.isSignInMode)) {
      if (!browserUtils.isMobileOrTabletDevice()) {
        this.emailInput.focus()
      }
    }
  }

  updateEmail(e) {
    const newEmail = {
      value: e.target.value,
      isValid: emailRegex.test(e.target.value)
    }
    this.setState({ email: newEmail })
  }

  updatePassword(e) {
    const newPassword = {
      value: e.target.value,
      isValid: passwordRegex.test(e.target.value)
    }
    this.setState({ password: newPassword })
  }

  updatePasswordConfirm(e) {
    const newPassword = {
      value: e.target.value,
      isValid: e.target.value === this.state.password.value
    }
    this.setState({ passwordConfirm: newPassword })
  }

  validateAndSubmit(e) {
    e.preventDefault()
    const { email, password, passwordConfirm } = this.state
    const { isSignInMode } = this.props

    if (email.isValid && password.isValid && (passwordConfirm.isValid || isSignInMode)) {
      isSignInMode ? this.props.signIn(email.value, password.value) : this.props.signUp(email.value, password.value, passwordConfirm.value)
    } else {
      this.setState({ submitAttempted: true })
    }
  }

  renderSignUpErrorMsgs(isEmailValid, isPasswordValid, isPasswordConfirmValid) {
    return (
      <div className="error-msgs">
        { !isEmailValid && <p className="error-msg"><img src={alertIcon} alt="alert" />Please enter a valid email</p> }
        { !isPasswordValid && <p className="error-msg"><img src={alertIcon} alt="alert" />Password must contain a minimum of 8 characters, at least 1 letter and 1 number</p> }
        { !isPasswordConfirmValid && <p className="error-msg"><img src={alertIcon} alt="alert" />Passwords do not match</p> }
      </div>
    )
  }

  renderServerErrorMsgs(serverErrorMsg) {
    return (
      <div className="error-msgs">
        <p className="error-msg"><img src={alertIcon} alt="alert" />{serverErrorMsg}</p>
      </div>
    )
  }

  render() {
    const { email, password, passwordConfirm, submitAttempted } = this.state
    const { isSignInMode, serverErrorMsg } = this.props
    const formValid = email.isValid && password.isValid && passwordConfirm.isValid

    return (
      <form className="auth-form review-overlay-form" onSubmit={this._validateAndSubmit} noValidate>
        <h4 className="center">Sign { isSignInMode ? 'in' : 'up'} to leave a review</h4>
        <fieldset>
          <label htmlFor="email">EMAIL</label>
          <input
            type="email"
            placeholder="Type your email..."
            name="email"
            id="email"
            value={email.value}
            onChange={this._updateEmail}
            ref={input => this.emailInput = input}
          />
          <label htmlFor="password">PASSWORD</label>
          <input
            type="password"
            placeholder="Type your password..."
            name="password"
            id="password"
            value={password.value}
            onChange={this._updatePassword}
          />
          { !isSignInMode && [
            <label key={1} htmlFor="password-confirm">CONFIRM PASSWORD</label>,
            <input
              key={2}
              type="password"
              placeholder="Confirm your password..."
              name="password-confirm"
              id="password-confirm"
              value={passwordConfirm.value}
              onChange={this._updatePasswordConfirm}
            />
            ]
          }
        </fieldset>
        <p className="oauth-text">
          <span>Or sign { isSignInMode ? 'in' : 'up'} using:</span>
          <a className="oauth-link" href="/api/users/auth/google_oauth2">Google+</a>
          <a className="oauth-link" href="/api/users/auth/facebook">Facebook</a>
        </p>
        <button
          type="submit"
          className="btn-transparent"
        >
          sign { isSignInMode ? 'in' : 'up'}
        </button>
        {(submitAttempted && !isSignInMode) &&
          this.renderSignUpErrorMsgs(email.isValid, password.isValid, passwordConfirm.isValid)
        }
        {serverErrorMsg && this.renderServerErrorMsgs(serverErrorMsg)}
      </form>
    )
  }
}

AuthForm.propTypes = {
  signIn: PropTypes.func.isRequired,
  signUp: PropTypes.func.isRequired,
  isSignInMode: PropTypes.bool,
  isVisible: PropTypes.bool,
  serverErrorMsg: PropTypes.string
}

export default AuthForm
